import React from "react";

export enum NotificationType {
  Pending = "Pending",
  General = "General",
  Handled = "Handled",
}

export interface Notification {
  description: string;
  type: NotificationType;
}

interface NotificationContextValue {
  pendingNotificationUnreadCount: number;
  generalNotificationUnreadCount: number;
  unreadNotifications: Notification[];
  setNotificationUnreadCount: (count: number) => void;
}

export const NotificationContext =
  React.createContext<NotificationContextValue>(null as any);
